// @flow
import React from 'react';
import { connect } from 'react-redux';
import SessionNoteCard from './SessionNoteCard';

type Props = {
    summarySession: any,
    blockTree: any,
    exerciseTree: any
};

const getExerciseCards = (session: {}, blockTree: {}, exerciseTree: {}) => {
    if (!session) {
        return [];
    }

    const exerciseCards = [];
    for (let i = 0; i < session.sets.length; i++) {
        const block = blockTree[session.sets[i]];
        for (let j = 0; j < block.exercises.length; j++) {
            const exercise = exerciseTree[block.exercises[j]];
            if (exercise.notes && exercise.notes.length > 0) {
                exerciseCards.push(
                    <SessionNoteCard
                        key={exercise.id}
                        title={exercise.title}
                        body={exercise.notes}
                    />
                );
            }
        }
    }
    return exerciseCards;
};

const SessionNotes = ({ summarySession, blockTree, exerciseTree }: Props) => {
    let sessionNotesCard = null;

    if (!summarySession) {
        return null;
    }

    const exerciseCards = getExerciseCards(
        summarySession,
        blockTree,
        exerciseTree
    );

    if (summarySession.notes.length > 0) {
        sessionNotesCard = (
            <SessionNoteCard
                title="Session Notes"
                body={summarySession.notes}
            />
        );
    }

    return (
        <div className="session-note-container">
            {sessionNotesCard}
            {exerciseCards}
        </div>
    );
};

const mapStateToProps = (state: {}, ownProps: any) => {
    let summarySession = null;
    if (ownProps.session) {
        summarySession =
            state.summary.calendarSummarySessionTree[
                ownProps.session.workout_id
            ];
    }

    return {
        summarySession: summarySession,
        exerciseTree: state.summary.calendarSummaryExerciseTree,
        blockTree: state.summary.calendarSummaryBlockTree,
        ...ownProps
    };
};

export default connect(mapStateToProps)(SessionNotes);



// WEBPACK FOOTER //
// ./src/view/calendar/components/SessionNotes.jsx